// Module
var code = "<div ng-if=\"!isMobile\"> <runner-page-description is-show=\"!isMobile\" page-header-text=\"Process Dashboard\" page-description=\"Dashboard of Process Usage.\"></runner-page-description> <exago-report report-mode=\"'ExecuteReport'\" report-folder=\"$ctrl.reportFolder\" report-name=\"$ctrl.reportName\"></exago-report> </div> ";
// Exports
export default code;